<template>
  <VDialog v-model="isVisible" :retain-focus="false" width="800" persistent attach="#LetsPage">
    <VCard v-if="isVisible">
      <VCardTitle>
        {{ $t('C40101.C40101B00301Dialog.7_cV_j9l8J9UpSifb7pf7') }}
      </VCardTitle>
      <VCardText v-debug>
        <h3>dialogData</h3>
        {{dialogData}}
      </VCardText>
      <VCardText>
        <colgroup>
          <col>
          <col style="width: 75px;">
          <col style="width: 65px;">
          <col style="width: 100px;">
          <col style="width: 120px;">
          <col style="width: 130px;">
          <col>
        </colgroup>
        <template v-if="dialogData.err_msg1_data">
          <tr>
            <td colspan="7" class="err_msg1_data_title">
              <span>
                {{ $t('C40101.C40101B00301Dialog.ww4QLTwNuWgWQ5lSm8DWf') }} <br>
                {{ $t('C40101.C40101B00301Dialog.TAbjWHfCGn67pqdB2ok0m') }} </span>

            </td>
          </tr>
          <tr v-for="(item) in dialogData.err_msg1_data" :key="item.id + '_err_msg1_data'">
            <!-- {{item}} -->
            <td>
            </td>
            <td>
              {{item.schedule_date}}
            </td>
            <td>
              {{item.time_limit_name2}}
            </td>
            <td>
              {{item.class_type_label}}{{item.school_year_name3}}{{item.subject_name3}}
            </td>
            <td>
              {{
                `${item.capacity === 1 ? 'm' : ''}${
                  item.time_division === 0 ? '' :
                  item.time_division === 1 ? '(f)' : '(s)'}${
                  item.student_name
                }`
              }}
            </td>
            <td>
              {{item.classroom_name3}}
            </td>
            <td>
            </td>
          </tr>
        </template>
        <template v-if="dialogData.err_msg2_data">
          <tr>
            <td colspan="7" class="err_msg2_data_title">
              {{ $t('C40101.C40101B00301Dialog.dRwQLTTuLz05B_N705bFz') }}
            </td>
          </tr>
          <tr v-for="(item) in dialogData.err_msg2_data" :key="item.id + '_err_msg2_data'">
            <!-- {{item}} -->
            <td>


            </td>
            <td>
              {{item.schedule_date}}
            </td>
            <td>
              {{item.time_limit_name2}}
            </td>
            <td>
              {{item.class_type_label}}{{item.school_year_name3}}{{item.subject_name3}}
            </td>
            <td>
              {{
                `${item.capacity === 1 ? 'm' : ''}${
                  item.time_division === 0 ? '' :
                  item.time_division === 1 ? '(f)' : '(s)'}${
                  item.student_name
                }`
              }}
            </td>
            <td>
              {{item.classroom_name3}}
            </td>
            <td>
            </td>
          </tr>
        </template>
        <template v-if="dialogData.err_msg3_data">
          <tr>
            <td colspan="7" class="err_msg3_data_title">
              {{ $t('C40101.C40101B00301Dialog.lbloBVpVLtDUGo7GFcoq1') }}
            </td>
          </tr>
          <tr v-for="(item) in dialogData.err_msg3_data" :key="item.id + '_err_msg3_data'">
            <!-- {{item}} -->
            <td>


            </td>
            <td>
              {{item.schedule_date}}
            </td>
            <td>
              {{item.time_limit_name2}}
            </td>
            <td>
              {{item.class_type_label}}{{item.school_year_name3}}{{item.subject_name3}}
            </td>
            <td>
              {{
                `${item.capacity === 1 ? 'm' : ''}${
                  item.time_division === 0 ? '' :
                  item.time_division === 1 ? '(f)' : '(s)'}${
                  item.student_name
                }`
              }}
            </td>
            <td>
              {{item.classroom_name3}}
            </td>
            <td>
            </td>
          </tr>
        </template>

      </VCardText>
      <VCardText v-debug>
        <h3>outputData</h3>
        {{outputData}}
      </VCardText>
      <VCardActions>
        <VSpacer></VSpacer>
        <VBtn
          v-bind="{
            color: '#AEAEAE',
            style: { color: '#FFFFFF' }
          }"
          @click="emitCancel">
          {{ $t('common.close') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  mixins:[
    DialogMixin
  ],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
.err_msg1_data_title{
  color: blue;
  font-size: 1.1rem;
}
.err_msg2_data_title{
  color: blue;
  font-size: 1.1rem;
}
.err_msg3_data_title{
  color: red;
  font-size: 1.1rem;
}
.err_msg_data_item_start{
  width: 30px;
}
</style>
